import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'pairRooms',
})
export class PairRoomsPipe implements PipeTransform {

    transform<T>(rooms: T[]): T[][] {
        if (!rooms || !Array.isArray(rooms)) {
            return [];
        }
        const pairedRooms: T[][] = [];
        for (let i = 0; i < rooms.length; i += 2) {
            pairedRooms.push(rooms.slice(i, i + 2));
        }
        return pairedRooms;
    }
}
